import { Subject } from 'rxjs';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { StepService } from './step.service';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent implements OnInit {

  stepCount: number;

  onDispose$: Subject<void> = new Subject<void>();
  currentStep: number;
  stepArray: Array<number> = [];

  constructor(private stepService: StepService) { }

  ngOnInit() {
    this.stepService.stepsAsync.pipe(takeUntil(this.onDispose$)).subscribe(steps => {
      this.stepCount = steps.length;
      this.stepArray = Array(steps.length).fill(0).map(Number.call, Number);
    });
    this.stepService.currentStep.pipe(takeUntil(this.onDispose$)).subscribe((step) => (this.currentStep = step));
  }

  ngOnDestroy() {
    this.onDispose$.next();
    this.onDispose$.complete();
  }

}


